import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ProjectIntegration, ProviderType } from '../../models/project-integration.model';
import { providerColor, providerLabel } from '../../shared/provider-meta';
import {
  BugTargetChoice,
  NO_BUG_TARGET_CHOICE,
  chooseBugBoard,
  chooseBugProvider,
  resolveBugTargets,
} from './bug-target-choice';

/**
 * Tracker-Umschaltung und Board-Auswahl einer Bug-Anlage (NEX-1348). Zeigt nur, was die
 * Ziele zur Wahl stellen — bei einem einzigen also nichts.
 *
 * <p>Die Ziele laedt der Aufrufer (im Runner {@code StepBugLinkService.creationTargets});
 * er haelt auch die Wahl ({@link choice}) und leitet das Ziel mit denselben Regeln ab.
 *
 * <p>Der Wirt nimmt keinen Platz ein: Umschaltung und Liste stehen in der Zeile des
 * Aufrufers wie dessen eigene Elemente, zwischen Eingabe und Anlage-Knopf.
 */
@Component({
  selector: 'app-bug-target-picker',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './bug-target-picker.component.html',
  styleUrl: './bug-target-picker.component.scss',
})
export class BugTargetPickerComponent {
  readonly targets = input.required<readonly ProjectIntegration[]>();
  /** Gesperrt nimmt die Auswahl nichts an — etwa fuer eine lesende Rolle. */
  readonly locked = input(false);
  readonly choice = model<BugTargetChoice>(NO_BUG_TARGET_CHOICE);

  readonly options = computed(() => resolveBugTargets(this.targets(), this.choice()));

  readonly providerLabel = providerLabel;
  readonly providerColor = providerColor;

  selectProvider(provider: ProviderType): void {
    if (this.locked()) return;
    this.choice.set(chooseBugProvider(provider));
  }

  selectBoard(boardId: string): void {
    if (this.locked()) return;
    this.choice.set(chooseBugBoard(this.choice(), boardId));
  }

  /**
   * Wie ein Board in der Auswahl heisst. Ein Label-Feld hat die Anbindung nicht; ihr
   * internes Kennzeichen kommt dem am naechsten, und ohne eines bleibt die Adresse.
   */
  boardLabel(integration: ProjectIntegration): string {
    return integration.projectKey?.trim() || integration.boardUrl;
  }
}
